import styled from '@emotion/styled';
import { Button, Typography } from '@material-ui/core';
import { COLOR_TEXT_MAIN } from '../../../../theme/colors';
import { PageTitleStyle } from '../../primitive/TypographyUI';
// import LoadingButton from '../../primitive/LoadingButton';

export const PrimaryButton = styled(Button)(`
  color: #FFFFFF;
  height: 40px;
  font-size: 14px;
  background: ${COLOR_TEXT_MAIN};
  font-weight: 700;
  border-color: ${COLOR_TEXT_MAIN};
  border-radius: 4px;
  padding: 12px 24px;
  text-transform: none;
  white-space: nowrap;
  :hover {
    background: #707889;
    border-color: #707889;
  }
  :disabled {
    background: #E6E7E8;
    color: rgba(75, 85, 106, 0.24);
    border: rgba(75, 85, 106, 0.24);
  }
`);

export const PrimarySmallButton = styled(Button)(`
  color: #FFFFFF;
  height: 32px;
  padding: 16px;
  font-size: 14px;
  background: ${COLOR_TEXT_MAIN};
  font-weight: 700;
  border-color: ${COLOR_TEXT_MAIN};
  border-radius: 4px;
  padding: 12px 24px;
  text-transform: none;
  white-space: nowrap;
  :hover {
    background: #707889;
    border-color: #707889;
  }
  :disabled {
    background: #E6E7E8;
    color: rgba(75, 85, 106, 0.24);
    border: rgba(75, 85, 106, 0.24);
  }
`);

export const SecondaryButton = styled(Button)(`
  color: ${COLOR_TEXT_MAIN};
  height: 40px;
  font-size: 14px;
  background: #FFFFFF;
  font-weight: 700;
  border: 1.5px solid #E6E7E8;
  border-radius: 4px;
  padding: 12px 24px;
  white-space: nowrap;
  :hover {
    background: #FFFFFF;
    color: #707889;
  }
`);

export const SecondarySmallButton = styled(Button)(`
  flex: 0 0 auto;
  color: ${COLOR_TEXT_MAIN};
  height: 32px;
  padding: 16px;
  font-size: 14px;
  background: #FFFFFF;
  font-weight: 700;
  border: 1.5px solid #E6E7E8;
  border-radius: 4px;
  white-space: nowrap;
  :hover {
    background: #FFFFFF;
    color: #707889;
  }
`);

export const DrawerHeader = styled('div')(`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 36px;
`);

export const DrawerTitle = styled(Typography)({
  ...PageTitleStyle,
});

export const DrawerContent = styled('div')(`
  padding: 40px 40px;
  width: 864px;
  height: calc(100% - 65px);
  position: relative;
  overflow-y: auto;
  fieldset {
    outline: none;
    border: 1.5px solid #E6E7E8;
  }
  .MuiOutlinedInput-root:hover fieldset {
    outline: none;
    border: 1.5px solid #E6E7E8;
  }
  .MuiOutlinedInput-root.Mui-focused {
    fieldset {
      outline: none;
      border: 1.5px solid #707889;
    }
  }
`);
